/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Multiselect from 'vue-multiselect'

require('./bootstrap');

window.Vue = require('vue');


import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

const sentryDSN = process.env.NODE_ENV === 'production' ? 'https://5b4a3e5ed260425eb001b620a4eac832@sentry.io/1243286' : 'https://cb1bb93d02c1475db9570603d18cc21f@sentry.io/1730272';

Sentry.init({
    dsn: sentryDSN,
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// import axios from 'axios'
// import VueAxios from 'vue-axios'
//
//
// Vue.use(VueAxios, axios)


Vue.use(Multiselect);

import VueRouter from 'vue-router'
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history'
});


window.laroute = require('./plugins/laroute.js');
window.moment = require('moment');



// import VueFormWizard from 'vue-form-wizard';
// Vue.use(VueFormWizard);

// import VueFormGenerator from "vue-form-generator/dist/vfg.js";


// import VueFormGenerator from "VueFormGenerator";
// import fieldCustomCheckbox from "./components/fields/fieldCustomCheckbox.vue";
Vue.component("fieldCustomCheckbox", require("./components/fields/fieldCustomCheckbox.vue"));
Vue.component("fieldBraintree", require("./components/fields/fieldBraintree.vue"));
Vue.component("fieldFailedPayment", require("./components/fields/fieldFailedPayment.vue"));


// import VueFormGenerator from "vue-form-generator/dist/vfg-core.js";
// Vue.component("custom-checkbox", CustomCheckbox);
// Vue.component('fieldCustomCheckbox', require('./components/fields/fieldCustomCheckbox.vue'));

// Vue.use(VueFormGenerator);

window.Event = new Vue();



Vue.component('module_obroki_upn', require('./components/modules/ObrokiUPN.vue'));
Vue.component('module_terms', require('./components/modules/Terms.vue'));
Vue.component('module_coupon', require('./components/modules/Coupon.vue'));
Vue.component('module_customer_address', require('./components/modules/CustomerAddress.vue'));
Vue.component('module_customer_business', require('./components/modules/CustomerBusiness.vue'));
Vue.component('module_dna_codes', require('./components/modules/DNACodes.vue'));
Vue.component("module_customer_data_confirmation", require("./components/modules/CustomerDataConfirmation.vue"));
Vue.component('module_guests', require('./components/modules/Guests.vue'));
Vue.component('module_payment_methods', require('./components/modules/PaymentMethodsBS3.vue'));
Vue.component('module_tracking', require('./components/modules/Tracking.vue'));
Vue.component('module_affiliate', require('./components/modules/Affiliate.vue'));
Vue.component('prijavnica', require('./components/Prijavnica.vue'));

Vue.component('savina-guarantee-bs3', require('./components/modules/savinaGuaranteebs3.vue'));
Vue.component('ticket-check', require('./components/TicketCheck.vue'));


Vue.component('helpers-copy_url', require('./components/helpers/CopyUrl.vue'));

Vue.component('affiliate_register', require('./components/affiliate/AffiliateRegister.vue'));


Vue.component('installments-pay', require('./components/installments/pay.vue'));


const appbs3 = new Vue({
    el: '#app',
    router
});



// WEBPACK FOOTER //
// ./resources/assets/js/appbs3.js